import React, { useState, useEffect, useContext } from "react";
import DataTable from "../components/DataTableComponents";
import IconUI from "../components/iu/icon_ui";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Tooltip } from "@mui/material";
import LoaderComponent from "../components/admin/LoaderComponent";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  Autocomplete,
  FormGroup,
  FormLabel,
} from "@mui/material";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { GrDocumentDownload } from "react-icons/gr";
import { maxLengthLimitInput, onlyNumber } from "../utils/inputsRules";
import { services } from "../services/api";
import { NotificacionContext } from "../context/notificacion_context";
import "dayjs/locale/es";
import ModalText from "../components/ModalText";
 
const Orientacion = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
 
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: 600,
    borderRadius: "40px",
    scrollbarWidth: "none",
  };
 
  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #661d40",
 
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: "auto",
    borderRadius: "40px",
    scrollbarWidth: "none",
  };
 
  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",
      sm: "80%",
      md: 1200,
    },
    bgcolor: "background.paper",
    border: "2px solid #661d40",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    overflowY: "scroll",
    height: {
      xs: "90vh",
      sm: "80vh",
      md: "90%",
    },
    borderRadius: "40px",
  };
 
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#005cbf"),
    backgroundColor: "#661d40",
 
    "&:hover": {
      backgroundColor: "#661d40",
 
    },
    borderRadius: "40px",
  }));
 
  const [loader, setLoader] = useState({
    loading: true,
  });
 
  const { showNotification } = useContext(NotificacionContext);
 
  const [state, setState] = useState({
    municipios: [],
    orientacion: [],
    observaciones: "",
    orientacionSeleccionado: {},
    openModalEditar: false,
    openModalEliminar: false,
    openObservaciones: false,
    openDocumento: false,
    FilterChecked: true,
  });
 
  const [formularioState, setFormulario] = useState({
    cedula_number: "",
    date: "",
    applicant_name: "",
    aplicant_phone: "",
    aplicant_email: "",
    locality_id: "",
    municipality_id: "",
    reasons_ceeav: "",
    other_reason: "",
    reason_description: "",
    actions_ceeav: [],
    other_action: "",
    action_description: "",
    is_victim: "",
    victim_type: "",
    folio_opc: "",
    folio_sopc: "",
    sopc_first_time: "",
    assigned_staff: "",
  });
 
  const normalizeValue = (value) =>
    value?.toUpperCase().replace(/[_\s]/g, "") || "";

  const normalizeActions = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value !== "string" || !value) return [];

    try {
      const parsedValue = JSON.parse(value);
      return Array.isArray(parsedValue) ? parsedValue : [parsedValue];
    } catch {
      return [value];
    }
  };

  const formatActions = (value) =>
    normalizeActions(value)
      .map((action) => actionLabels[action] || action)
      .join(", ");

  const isPrimerContacto =normalizeValue(localStorage.getItem("area_type")) === "PRIMERCONTACTO";

  const [errors, setErrors] = useState({});
 
  const [openModal, setOpenModal] = useState(false);
  const reasonLabels = {
    A: "INFORMACIÓN DE LOS SERVICIOS DE LA CEEAV",
    B: "INFORMACIÓN RELATIVA A OTRAS INSTITUCIONES",
    C: "USUARIO NUEVO QUE SOLICITA ATENCIÓN DE LA CEEAV",
    D: "USUARIO QUE SOLICITA INFORMACIÓN DE CASO",
    E: "CONTENCIÓN",
    F: "ACOMPAÑAMIENTO",
    G: "ASESORÍA PSICOLOGICA",
    H: "PSICOTERAPIA",
    OTRO: "OTRO",
  };
  const actionLabels = {
    A: "SE BRINDÓ INFORMACIÓN",
    B: "DERIVACIÓN AL DEPARTAMENTO DE VINCULACIÓN CON INSTITUCIÓN PARA CANALIZACIÓN",
    C: "ATENCIÓN DE PRIMER CONTACTO DE LA CEEAV",
    D: "DERIVACIÓN A OTRA ÁREA DE LA CEEAV PARA ATENCIÓN",
    OTRO: "OTRO",
  }
 
  const handleCloseModal = () => {
    setOpenModal(false);
    limpiarFormulario();
  };
 
  const openModalEliminar = (data) => {
    setState({
      ...state,
      openModalEliminar: true,
      orientacionSeleccionado: data,
    });
  };
 
  const handleCloseEliminar = () => {
    setState({
      ...state,
      openModalEliminar: false,
    });
  };
 
  const openModalEditar = async (data) => {
    let localidades = await services({
      method: "GET",
      service: `localities?municipality_id=${data.municipality_id}`,
      body: null,
    });
    if (localidades.status === 200) {
      setFormulario((formularioState) => ({
        ...formularioState,
        municipio: data ? data.municipio_id : "",
        localidad: "",
      }));
    } else {
      showNotification("error", "Ups...", localidades.data.message, null, 4);
    }
    setState({
      ...state,
      openModalEditar: true,
      orientacionSeleccionado: data,
      localidades: localidades.data,
    });
  };
 
  const handleCloseEditar = () => {
    setState({
      ...state,
      openModalEditar: false,
    });
  };
 
  // const openModalObservaciones = (data) => {
  //   setState({ ...state, openObservaciones: true, observaciones: data });
  // };
 
  const handleCloseObservaciones = () => {
    setState({ ...state, openObservaciones: false });
  };
 
  const handleCloseDocumento = () => {
    setState({ ...state, openDocumento: false });
  };

  const orientacionTableData = (state.orientacion || []).map((item) => ({
    date: item.date ? dayjs(item.date).isValid() ? dayjs(item.date).format("DD-MM-YYYY") : "" : "",
    applicant_name: item.applicant_name ?? "",
    municipality_name: item.municipality?.name ?? "",
    victim_type: item.victim_type ?? "",
    aplicant_phone: item.aplicant_phone ?? "",
    reasons_ceeav: reasonLabels[item.reasons_ceeav] || item.reasons_ceeav || "",
    actions_ceeav: formatActions(item.actions_ceeav),
    folio_sopc: item.folio_sopc ?? "",
    assigned_staff: item.assigned_staff ?? "",
  }));
 
  const columns = [
    {
      name: "date",
      label: "FECHA",
      options: {
        filter: true,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const fecha = state.orientacion[dataIndex].date;
          const alta = dayjs(fecha);
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {alta.isValid() ? alta.format("DD-MM-YYYY") : "-"}
            </div>
          );
        },
        filterType: "custom",
        customFilterListOptions: {
          render: (v) => {
            if (v[0] && v[1] && state.FilterChecked) {
              return [
                `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}`,
                `FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`,
              ];
            } else if (v[0] && v[1] && !state.FilterChecked) {
              return `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}, FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
            } else if (v[0]) {
              return `FECHA INICIO: ${dayjs(v[0], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
            } else if (v[1]) {
              return `FECHA FINAL: ${dayjs(v[1], "DD-MM-YYYY").format("DD-MM-YYYY")}`;
            }
            return [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, "");
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }
 
            return filterList;
          },
        },
        filterOptions: {
          names: [],
          logic: (fecha_creacion, filters) => {
            const fechaMoment = dayjs(fecha_creacion);

            if (filters[0] && filters[1]) {
              return (
                fechaMoment.isBefore(dayjs(filters[0], "DD-MM-YYYY")) ||
                fechaMoment.isAfter(dayjs(filters[1], "DD-MM-YYYY"))
              );
            } else if (filters[0]) {
              return fechaMoment.isBefore(dayjs(filters[0], "DD-MM-YYYY"));
            } else if (filters[1]) {
              return fechaMoment.isAfter(dayjs(filters[1], "DD-MM-YYYY"));
            }

            return false;
          },
          display: (filterList, onChange, index, column) => (
            <div>
              <FormLabel className="mb-2" style={{ fontSize: "12px" }}>
                RANGO DE FECHAS
              </FormLabel>
              <FormGroup row>
                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="INICIO"
                    slotProps={{ textField: { size: "small" } }}
                    value={
                      filterList[index][0]
                        ? dayjs(filterList[index][0], "DD-MM-YYYY")
                        : null
                    }
                    views={["day", "month", "year"]}
                    onChange={(event) => {
                      filterList[index][0] = dayjs(event).format("DD-MM-YYYY");
                      onChange(filterList[index], index, column);
                    }}
                    style={{ width: "40%" }}
                  />
                </LocalizationProvider>
 
                <LocalizationProvider
                  adapterLocale="es"
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    label="FINAL"
                    slotProps={{ textField: { size: "small" } }}
                    value={
                      filterList[index][1]
                        ? dayjs(filterList[index][1], "DD-MM-YYYY")
                        : null
                    }
                    views={["day", "month", "year"]}
                    onChange={(event) => {
                      filterList[index][1] = dayjs(event).format("DD-MM-YYYY");
                      onChange(filterList[index], index, column);
                    }}
                    style={{ width: "40%", marginLeft: "10px" }}
                  />
                </LocalizationProvider>
              </FormGroup>
            </div>
          ),
        },
      },
    },
    {
      name: "applicant_name",
      label: "NOMBRE",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let applicant_name = state.orientacion[dataIndex].applicant_name;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {applicant_name}
            </div>
          );
        },
      },
    },
    {
      name: "municipality_name",
      label: "MUNICIPIO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let municipality_name = state.orientacion[dataIndex]?.municipality?.name;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {municipality_name}
            </div>
          );
        },
      },
    },
    {
      name: "victim_type",
      label: "TIPO DE VÍCTIMA",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let victim_type = state.orientacion[dataIndex].victim_type;
          if (victim_type !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {victim_type}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "aplicant_phone",
      label: "TELÉFONO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let aplicant_phone = state.orientacion[dataIndex].aplicant_phone;
          if (aplicant_phone !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {aplicant_phone}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "reasons_ceeav",
      label: "ASUNTO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let reasons_ceeav = state.orientacion[dataIndex].reasons_ceeav;
          const reasonLabel = reasonLabels[reasons_ceeav] || reasons_ceeav;
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {reasonLabel}
            </div>
          );
        },
      },
    },
    {
      name: "actions_ceeav",
      label: "ACCIONES REALIZADAS",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const actionLabel = formatActions(
            state.orientacion[dataIndex].actions_ceeav,
          );
          return (
            <div
              className="d-flex align-items-center"
              style={{ height: "60px" }}
            >
              {actionLabel}
            </div>
          );
        },
      },
    },
    {
      name: "folio_sopc",
      label: "FOLIO SOPC DE SEGUIMIENTO",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let folio_sopc = state.orientacion[dataIndex].folio_sopc;
          if (folio_sopc !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {folio_sopc}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "assigned_staff",
      label: "CANALIZADO A",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let assigned_staff = state.orientacion[dataIndex].assigned_staff;
          if (assigned_staff !== null) {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex align-items-center"
              >
                {assigned_staff}
              </div>
            );
          } else {
            return (
              <div
                style={{ height: "60px" }}
                className="d-flex  justify-content-center align-items-center"
              >
                -
              </div>
            );
          }
        },
      },
    },
    {
      name: "operaciones",
      label: "OPERACIONES",
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            <div
              style={{ height: "60px" }}
              className="d-flex align-items-center"
            >
              <Tooltip title="EDITAR ORIENTACIÓN">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    openModalEditar(state.orientacion[dataIndex]);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <AiOutlineEdit />
                  </IconUI>
                </div>
              </Tooltip>
              {(!isPrimerContacto) && (
                <Tooltip title="ELIMINAR ORIENTACIÓN">
                  <div
                    style={{ height: 30, width: 30, zIndex: 0 }}
                    className="cta cta--primary cta--icon icon_btn"
                    onClick={() => {
                      openModalEliminar(state.orientacion[dataIndex]);
                    }}
                  >
                    <IconUI size={"20px"} color={"black"}>
                      <AiOutlineDelete />
                    </IconUI>
                  </div>
                </Tooltip>
              )}
              <Tooltip title="FORMATO DE ORIENTACIÓN">
                <div
                  style={{ height: 30, width: 30, zIndex: 0 }}
                  className="cta cta--primary cta--icon icon_btn"
                  onClick={() => {
                    descargarDocumentos(state.orientacion[dataIndex].id);
                  }}
                >
                  <IconUI size={"20px"} color={"black"}>
                    <GrDocumentDownload />
                  </IconUI>
                </div>
              </Tooltip>
            </div>
          </>
        ),
      },
    },
  ];
 
  // const handleCedulaNumber = (e) => {
  //   setFormulario({
  //     ...formularioState,
  //     cedula_number: uppercaseText(e.target.value),
  //   });
  // };
  // const handleDate = (e) => {
  //   setFormulario({ ...formularioState, date: e.target.value });
  // };
  const handleApplicant_name = (e) => {
    setFormulario({
      ...formularioState,
      applicant_name: uppercaseText(e.target.value),
    });
  };
  const handleAplicant_phone = (e) => {
    setFormulario({ ...formularioState, aplicant_phone: e.target.value });
  };
  const handleAplicant_email = (e) => {
    setFormulario({
      ...formularioState,
      aplicant_email: uppercaseText(e.target.value),
    });
  };
  const handleReasons_ceeav = (e) => {
    const value = e.target.value;
    setFormulario({
      ...formularioState,
      reasons_ceeav: value,
      other_reason: value === "OTRO" ? formularioState.other_reason : null,
    });
  };
  const handleOther_reason = (e) => {
    setFormulario({
      ...formularioState,
      other_reason: uppercaseText(e.target.value),
    });
  };
  const handleReason_description = (e) => {
    setFormulario({
      ...formularioState,
      reason_description: uppercaseText(e.target.value),
    });
  };
  const handleActions_ceeav = (e) => {
    const value = normalizeActions(e.target.value);
    setFormulario({
      ...formularioState,
      actions_ceeav: value,
      other_action: value.includes("OTRO") ? formularioState.other_action : "",
    });
  };
  const handleOther_action = (e) => {
    setFormulario({
      ...formularioState,
      other_action: uppercaseText(e.target.value),
    });
  };
  const handleAction_description = (e) => {
    setFormulario({
      ...formularioState,
      action_description: uppercaseText(e.target.value),
    });
  };

  const parseBooleanSelectValue = (value) => {
    if (value === "SI") return true;
    if (value === "NO") return false;
    return "";
  };

  const uppercaseText = (value) =>
    typeof value === "string" ? value.toUpperCase() : value;

  const handleIs_victim = (e) => {
    const isVictim = parseBooleanSelectValue(e.target.value);
    setFormulario({
      ...formularioState,
      is_victim: isVictim,
      victim_type: isVictim ? formularioState.victim_type : "",
    });
  };
  const handleVictim_type = (e) => {
    setFormulario({ ...formularioState, victim_type: e.target.value });
  };
  const handleFolio_opc = (e) => {
    setFormulario({
      ...formularioState,
      folio_opc: parseBooleanSelectValue(e.target.value),
    });
  };
  const handleFolio_sopc = (e) => {
    setFormulario({
      ...formularioState,
      folio_sopc: uppercaseText(e.target.value),
    });
  };
  const handleSopc_first_time = (e) => {
    setFormulario({
      ...formularioState,
      sopc_first_time: uppercaseText(e.target.value),
    });
  };  
  const handleAssigned_staff = (e) => {
    setFormulario({
      ...formularioState,
      assigned_staff: uppercaseText(e.target.value),
    });
  };
  const handleMunicipality_id = async (e) => {
    if (e === null) {
      setFormulario((formularioState) => ({
        ...formularioState,
        municipality_id: "",
        locality_id: "",
      }));
    } else {
      let localidades = await services({
        method: "GET",
        service: `localities?municipality_id=${e.id}`,
        body: null,
      });
      if (localidades.status === 200) {
        setFormulario((formularioState) => ({
          ...formularioState,
          municipality_id: e ? e.id : "",
          locality_id: "",
        }));
        setState({ ...state, localidades: localidades.data });
      } else {
        showNotification("error", "Ups...", localidades.message, null, 4);
      }
    }
  };
  const handleLocality_id = (e) => {
    setFormulario({ ...formularioState, locality_id: e.target.value });
  };

  // const handleSeleccionadoCedula_number = (e) => {
  //   setState({
  //     ...state,
  //     orientacionSeleccionado: {
  //       ...state.orientacionSeleccionado,
  //       cedula_number: e.target.value,
  //     },
  //   });
  // };
  // const handleSeleccionadoDate = (e) => {
  //   if (e === null) {
  //     setState({
  //       ...state,
  //       orientacionSeleccionado: {
  //         ...state.orientacionSeleccionado,
  //         date: null,
  //       },
  //     });
  //   } else {
  //     const selectedDate = dayjs(e.$d);
  //     setState({
  //       ...state,
  //       orientacionSeleccionado: {
  //         ...state.orientacionSeleccionado,
  //         date: selectedDate.format("YYYY-MM-DD"),
  //       },
  //     });
  //   }
  // };
  const handleSeleccionadoApplicant_name = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        applicant_name: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoAplicant_phone = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        aplicant_phone: e.target.value,
      },
    });
  };
  const handleSeleccionadoAplicant_email = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        aplicant_email: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoReasons_ceeav = (e) => {
    const value = e.target.value;
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        reasons_ceeav: value,
        other_reason:
          value === "OTRO" ? state.orientacionSeleccionado.other_reason : null,
      },
    });
  };
  const handleSeleccionadoOther_reason = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        other_reason: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoReason_description = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        reason_description: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoActions_ceeav = (e) => {
    const value = normalizeActions(e.target.value);
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        actions_ceeav: value,
        other_action:
          value.includes("OTRO")
            ? state.orientacionSeleccionado.other_action
            : "",
      },
    });
  };
  const handleSeleccionadoOther_action = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        other_action: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoAction_description = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        action_description: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoIs_victim = (e) => {
    const isVictim = parseBooleanSelectValue(e.target.value);
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        is_victim: isVictim,
        victim_type: isVictim ? state.orientacionSeleccionado.victim_type : null,
      },
    });
  };
  const handleSeleccionadoVictim_type = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        victim_type: e.target.value,
      },
    });
  };
    const handleSeleccionadoFolio_opc = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        folio_opc: parseBooleanSelectValue(e.target.value),
      },
    });
  };
  const handleSeleccionadoFolio_sopc = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        folio_sopc: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoSopc_first_time = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        sopc_first_time: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoAssigned_staff = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        assigned_staff: uppercaseText(e.target.value),
      },
    });
  };
  const handleSeleccionadoMunicipality_id = async (e) => {
    if (e === null) {
      setState({
        ...state,
        localidades: [],
        orientacionSeleccionado: {
          ...state.orientacionSeleccionado,
          municipality_id: "",
        },
      });
    } else {
      let localidades = await services({
        method: "GET",
        service: `localities?municipality_id=${e.id}`,
        body: null,
      });
      if (localidades.status === 200) {
        setState({
          ...state,
          localidades: localidades.data,
          orientacionSeleccionado: {
            ...state.orientacionSeleccionado,
            municipality_id: e ? e.id : null,
            locality_id: null,
          },
        });
      } else {
        showNotification("error", "Ups...", localidades.message, null, 4);
      }
    }
  };
  const handleSeleccionadoLocality_id = (e) => {
    setState({
      ...state,
      orientacionSeleccionado: {
        ...state.orientacionSeleccionado,
        locality_id: e.target.value,
      },
    });
  };

  const regexEmail = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/;
  const validarFormulario = () => {
    let newErrors = {};
    if (!formularioState.applicant_name) {
      newErrors.applicant_name = "Este Campo es Requerido";
    }
    if (!formularioState.aplicant_phone) newErrors.aplicant_phone = "Este campo es requerido";
    else if (formularioState.aplicant_phone.length < 10) newErrors.aplicant_phone = "Favor poner un número de 10 dígitos";
    if (formularioState.aplicant_email !== "") {
      let valido = regexEmail.test(formularioState.aplicant_email);
      if (!valido) {
        newErrors.aplicant_email = "Ingrese un email válido";
      }
    }
    if (!formularioState.reasons_ceeav) {
      newErrors.reasons_ceeav = "Este Campo es Requerido";
    }
    if (formularioState.reasons_ceeav === "OTRO" && !formularioState.other_reason) newErrors.other_reason = "Este campo es requerido";
    if (!formularioState.reason_description) {
      newErrors.reason_description = "Este Campo es Requerido";
    }
    const selectedActions = normalizeActions(formularioState.actions_ceeav);
    if (!selectedActions.length) {
      newErrors.actions_ceeav = "Este Campo es Requerido";
    }
    if (selectedActions.includes("OTRO") && !formularioState.other_action) newErrors.other_action = "Este campo es requerido";

    if (!formularioState.action_description) {
      newErrors.action_description = "Este Campo es Requerido";
    }
    if (formularioState.is_victim === "" || formularioState.is_victim === null) {
      newErrors.is_victim = "Este Campo es Requerido";
    }
    if (formularioState.is_victim === true && !formularioState.victim_type) newErrors.victim_type = "Este campo es requerido";

    if (formularioState.folio_opc === "" || formularioState.folio_opc === null) {
      newErrors.folio_opc = "Este Campo es Requerido";
    }
    if(!formularioState.assigned_staff){
      newErrors.assigned_staff = "Este Campo es Requerido";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validarEditar = () => {
    let newErrors = {};
    if (!state.orientacionSeleccionado.applicant_name) {
      newErrors.applicant_name = "Este Campo es Requerido";
    }
    if (!state.orientacionSeleccionado.aplicant_phone) newErrors.aplicant_phone = "Este campo es requerido";
    else if (state.orientacionSeleccionado.aplicant_phone?.length < 10) newErrors.aplicant_phone = "Favor poner un número de 10 dígitos";
    if (      
      state.orientacionSeleccionado.aplicant_email !== null &&
      state.orientacionSeleccionado.aplicant_email !== "") {
      let valido = regexEmail.test(state.orientacionSeleccionado.aplicant_email);
      if (!valido) {
        newErrors.aplicant_email = "Ingrese un email válido";
      }
    }
    if (!state.orientacionSeleccionado.reasons_ceeav) {
      newErrors.reasons_ceeav = "Este Campo es Requerido";
    }
    if (state.orientacionSeleccionado.reasons_ceeav === "OTRO" && !state.orientacionSeleccionado.other_reason) newErrors.other_reason = "Este campo es requerido";
    if (!state.orientacionSeleccionado.reason_description) {
      newErrors.reason_description = "Este Campo es Requerido";
    }
    const selectedActions = normalizeActions(
      state.orientacionSeleccionado.actions_ceeav,
    );
    if (!selectedActions.length) {
      newErrors.actions_ceeav = "Este Campo es Requerido";
    }
    if (selectedActions.includes("OTRO") && !state.orientacionSeleccionado.other_action) newErrors.other_action = "Este campo es requerido";
    if (!state.orientacionSeleccionado.action_description) {
      newErrors.action_description = "Este Campo es Requerido";
    }
    if (
      state.orientacionSeleccionado.is_victim === "" ||
      state.orientacionSeleccionado.is_victim === null
    ) {
      newErrors.is_victim = "Este Campo es Requerido";
    }
    if (state.orientacionSeleccionado.is_victim === true && !state.orientacionSeleccionado.victim_type) newErrors.victim_type = "Este campo es requerido";

    if (
      state.orientacionSeleccionado.folio_opc === "" ||
      state.orientacionSeleccionado.folio_opc === null
    ) {
      newErrors.folio_opc = "Este Campo es Requerido";
    }
    if(!state.orientacionSeleccionado.assigned_staff){
      newErrors.assigned_staff = "Este Campo es Requerido";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const mostrarOrientaciones = async () => {
    setLoader({ ...loader, loading: true });
    let orientaciones = await services({
      method: "GET",
      service: `orientation`,
      body: null,
    });
    let municipios = await services({
      method: "GET",
      service: `municipalities`,
      body: null,
    });
    if (orientaciones.status === 200 && municipios.status === 200) {
      setState({
        ...state,
        orientacion: orientaciones.data,
        municipios: municipios.data,
      });
      setLoader({ ...loader, loading: false });
    } else {
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups... Algo Ocurrió",
        "Vuelva a intentarlo mas tarde ",
        null,
        4,
      );
    }
  };

  const limpiarFormulario = () => {
    setFormulario({
      ...formularioState,
      applicant_name: "",
      aplicant_phone: "",
      aplicant_email: "",
      locality_id: "",
      municipality_id: "",
      reasons_ceeav: "",
      other_reason: "",
      reason_description: "",
      actions_ceeav: [],
      other_action: "",
      action_description: "",
      is_victim: "",
      victim_type: "",
      folio_opc: "",
      folio_sopc: "",
      sopc_first_time: "",
      assigned_staff: "",
    });
  };

  const crearOrientacion = async () => {
    if (validarFormulario()) {
      setLoader({ ...loader, loading: true });
      const orientacion = await services({
        method: "POST",
        service: "orientation",
        body: {
          applicant_name: formularioState.applicant_name,
          aplicant_phone: formularioState.aplicant_phone,
          aplicant_email: formularioState.aplicant_email,
          locality_id: formularioState.locality_id,
          municipality_id: formularioState.municipality_id,
          reasons_ceeav: formularioState.reasons_ceeav,
          other_reason: formularioState.other_reason,
          reason_description: formularioState.reason_description,
          actions_ceeav: normalizeActions(formularioState.actions_ceeav),
          other_action: formularioState.other_action,
          action_description: formularioState.action_description,
          is_victim: formularioState.is_victim,
          victim_type: formularioState.victim_type,
          folio_opc: formularioState.folio_opc,
          folio_sopc: formularioState.folio_sopc,
          sopc_first_time: formularioState.sopc_first_time,
          assigned_staff: formularioState.assigned_staff,
        },
      });
      if (orientacion.status === 201) {
        let orientaciones = await services({
          method: "GET",
          service: `orientation`,
          body: null,
        });
        if (orientaciones.status === 200) {
          setLoader({ ...loader, loading: false });
          limpiarFormulario();
          setState({ ...state, orientacion: orientaciones.data });
          showNotification(
            "success",
            "Orientación",
            "Se ha Agregado con Éxito",
            null,
            4,
          );
          setOpenModal(false);
        }
      } else {
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "Error al agregar la Orientación",
          null,
          4,
        );
        limpiarFormulario();
        setOpenModal(false);
        setLoader({ ...loader, loading: false });
      }
    } else {
      showNotification(
        "error",
        "ups...Error ",
        "Por favor llena todos los campos",
        null,
        4,
      );
      setLoader({ ...loader, loading: false });
    }
  };

  const editarOrientacion = async () => {
    setLoader({ ...loader, loading: true });
    if (validarEditar()) {
      const orientacion = await services({
        method: "PUT",
        service: `orientation/${state.orientacionSeleccionado.id}`,
        body: {
          applicant_name: state.orientacionSeleccionado.applicant_name,
          aplicant_phone: state.orientacionSeleccionado.aplicant_phone,
          aplicant_email: state.orientacionSeleccionado.aplicant_email,
          locality_id: state.orientacionSeleccionado.locality_id,
          municipality_id: state.orientacionSeleccionado.municipality_id,
          reasons_ceeav: state.orientacionSeleccionado.reasons_ceeav,
          other_reason: state.orientacionSeleccionado.other_reason,
          reason_description: state.orientacionSeleccionado.reason_description,
          actions_ceeav: normalizeActions(
            state.orientacionSeleccionado.actions_ceeav,
          ),
          other_action: state.orientacionSeleccionado.other_action,
          action_description: state.orientacionSeleccionado.action_description,
          is_victim: state.orientacionSeleccionado.is_victim,
          victim_type: state.orientacionSeleccionado.victim_type,
          folio_opc: state.orientacionSeleccionado.folio_opc,
          folio_sopc: state.orientacionSeleccionado.folio_sopc,
          sopc_first_time: state.orientacionSeleccionado.sopc_first_time,
          assigned_staff: state.orientacionSeleccionado.assigned_staff,
        },
      });
      if (orientacion.status === 200) {
        let orientaciones = await services({
          method: "GET",
          service: `orientation`,
          body: null,
        });
        if (orientaciones.status === 200) {
          setState({ ...state, orientacion: orientaciones.data, openModalEditar: false });
          showNotification(
            "success",
            "Orientación",
            "Editada con Éxito",
            null,
            4,
          );
          setLoader({ ...loader, loading: false });
        } else {
          showNotification(
            "error",
            "Ups... Algo Sucedió",
            "Error al Editar Orientación",
            null,
            4,
          );
          setState({ ...state, openModalEditar: false });
          setLoader({ ...loader, loading: false });
        }
      }
    } else {
      setLoader({ ...loader, loading: false });
      showNotification("error", "Verifica", "Los campos marcados", null, 4);
    }
  };

  const descargarDocumentos = async (id) => {
    setLoader({ ...loader, loading: true });
    let response = await services({
      method: "GET",
      service: `orientation/${id}/pdf`,
      body: null,
    });
    setLoader({ ...loader, loading: false });
    if (response.status === 200) {
      const archivoBase64 = response.data?.archivo || "";
      const rawBase64 = archivoBase64.replace(/^data:application\/pdf;base64,/, "");
      setState({
        ...state,
        openDocumento: true,
        openImprimir: false,
        urlFrame: rawBase64,
      });
    } else {
      setState({ ...state, openImprimir: false });
      showNotification(
        "error",
        "Ups...Algo Sucedió",
        response?.data?.message || "No se pudo cargar el documento",
        null,
        4,
      );
    }
  };

  const eliminarOrientacion = async () => {
    setLoader({ ...loader, loading: true });
    const orientacion = await services({
      method: "DELETE",
      service: `orientation/${state.orientacionSeleccionado.id}`,
      body: null,
    });
    if (orientacion.status === 200) {
      let orientaciones = await services({
        method: "GET",
        service: `orientation`,
        body: null,
      });
      if (orientaciones.status === 200) {
        setState({
          ...state,
          orientacion: orientaciones.data,
          openModalEliminar: false,
        });
        showNotification(
          "success",
          "Orientación",
          "Eliminada con Éxito",
          null,
          4,
        );
        setLoader({ ...loader, loading: false });
      } else {
        setState({ ...state, openModalEliminar: false });
        setLoader({ ...loader, loading: false });
        showNotification(
          "error",
          "Ups... Algo sucedió",
          "Error al Eliminar Orientación",
          null,
          4,
        );
      }
    } else {
      setState({ ...state, openModalEliminar: false });
      setLoader({ ...loader, loading: false });
      showNotification(
        "error",
        "Ups... Algo sucedió",
        "Error al Eliminar Orientación",
        null,
        4,
      );
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      mostrarOrientaciones();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className=" justify-content-center align-items-start py-4">
        {loader.loading && <LoaderComponent />}
        <div className="container">
          <Grid
            sx={{ marginTop: 3 }}
            container
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={2}
          >
            <Grid item>
              <ColorButton
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Nuevo Registro
              </ColorButton>
            </Grid>
          </Grid>
        </div>
        <DataTable
          data={orientacionTableData}
          title="TABLA DE ORIENTACIONES"
          columns={columns}
        />

        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">NUEVA ORIENTACIÓN</h3>
            <hr />
            <h5>DATOS GENERALES</h5>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="NOMBRE DEL SOLICITANTE"
                  variant="outlined"
                  error={!!errors.applicant_name}
                  helperText={errors.applicant_name || ""}
                  value={formularioState.applicant_name}
                  onChange={handleApplicant_name}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-telefono"
                  label="TELEFONO"
                  variant="outlined"
                  error={!!errors.aplicant_phone}
                  helperText={errors.aplicant_phone || ""}
                  onChange={handleAplicant_phone}
                  value={formularioState.aplicant_phone}
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-correo"
                  label="CORREO ELECTRÓNICO"
                  variant="outlined"
                  value={formularioState.aplicant_email}
                  error={errors.aplicant_email ? true : false}
                  helperText={errors.aplicant_email || ""}
                  onChange={handleAplicant_email}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={state.municipios || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  id="textFile-area"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.municipios.find(
                      (option) => option.id === formularioState.municipality_id,
                    ) || null
                  }
                  onChange={(event, newValue) => handleMunicipality_id(newValue)}
                  renderInput={(params) => (
                    <TextField
                    {...params}
                      variant="outlined"
                      label="MUNICIPIO"
                      error={!!errors.municipality_id}
                      helperText={errors.municipality_id || ""}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="LOCALIDAD"
                  variant="outlined"
                  select
                  error={!!errors.locality_id}
                  helperText={errors.locality_id || ""}
                  onChange={handleLocality_id}
                  value={formularioState.locality_id || ""}
                >
                  {state.localidades?.length > 0 ? (
                    state.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value={null}>
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="MOTIVO DE ORIENTACIÓN"
                  variant="outlined"
                  select
                  error={!!errors.reasons_ceeav}
                  helperText={errors.reasons_ceeav || ""}
                  onChange={handleReasons_ceeav}
                  value={formularioState.reasons_ceeav || "" }
                >
                  <MenuItem value={"A"}>INFORMACIÓN DE LOS SERVICIOS DE LA CEEAV</MenuItem>
                  <MenuItem value={"B"}>INFORMACIÓN RELATIVA A OTRAS INSTITUCIONES</MenuItem>
                  <MenuItem value={"C"}>USUARIO NUEVO QUE SOLICITA ATENCIÓN DE LA CEEAV</MenuItem>
                  <MenuItem value={"D"}>USUARIO QUE SOLICITA INFORMACIÓN DE CASO</MenuItem>
                  <MenuItem value={"E"}>CONTENCIÓN</MenuItem>
                  <MenuItem value={"F"}>ACOMPAÑAMIENTO</MenuItem>
                  <MenuItem value={"G"}>ASESORÍA PSICOLOGICA</MenuItem>
                  <MenuItem value={"H"}>PSICOTERAPIA</MenuItem>
                  <MenuItem value={"OTRO"}>OTRO</MenuItem>
                </TextField>
              </Grid>
              {formularioState.reasons_ceeav === "OTRO" && (
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-other-reason"
                    label="ESPECIFIQUE OTRO MOTIVO"
                    variant="outlined"
                    error={!!errors.other_reason}
                    helperText={errors.other_reason || ""}
                    value={formularioState.other_reason}
                    onChange={handleOther_reason}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoM"
                  label="NARRACIÓN DE LA SOLICITUD"
                  variant="outlined"
                  error={!!errors.reason_description}
                  helperText={errors.reason_description || ""}
                  value={formularioState.reason_description}
                  onChange={handleReason_description}
                  
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="ACCIONES"
                  variant="outlined"
                  select
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) =>
                      selected
                        .map((action) => actionLabels[action] || action)
                        .join(", "),
                  }}
                  error={!!errors.actions_ceeav}
                  helperText={errors.actions_ceeav || ""}
                  onChange={handleActions_ceeav}
                  value={normalizeActions(formularioState.actions_ceeav)}
                >
                  <MenuItem value={"A"}>SE BRINDÓ INFORMACIÓN</MenuItem>
                  <MenuItem value={"B"}>DERIVACIÓN AL DEPARTAMENTO DE VINCULACIÓN CON INSTITUCIÓN PARA CANALIZACIÓN</MenuItem>
                  <MenuItem value={"C"}>ATENCIÓN DE PRIMER CONTACTO DE LA CEEAV</MenuItem>
                  <MenuItem value={"D"}>DERIVACIÓN A OTRA ÁREA DE LA CEEAV PARA ATENCIÓN</MenuItem>
                  <MenuItem value={"OTRO"}>OTRO</MenuItem>
                </TextField>
              </Grid>
              {normalizeActions(formularioState.actions_ceeav).includes("OTRO") && (
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-other-action"
                    label="ESPECIFIQUE OTRA ACCIÓN"
                    variant="outlined"
                    error={!!errors.other_action}
                    helperText={errors.other_action || ""}
                    value={formularioState.other_action}
                    onChange={handleOther_action}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoM"
                  label="DESCRIPCIÓN DE LA ACCIÓN"
                  variant="outlined"
                  error={!!errors.action_description}
                  helperText={errors.action_description || ""}
                  value={formularioState.action_description}
                  onChange={handleAction_description}
                />
              </Grid>
              <Grid item xs={12}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-calle"
                    label="ES VÍCTIMA"
                    variant="outlined"
                    error={!!errors.is_victim}
                    helperText={errors.is_victim || ""}
                    select
                    value={
                      formularioState.is_victim === true
                        ? "SI"
                        : formularioState.is_victim === false
                        ? "NO"
                        : ""
                    }
                    onChange={handleIs_victim}
                  >
                    <MenuItem value="SI">SI</MenuItem>
                    <MenuItem value="NO">NO</MenuItem>
                  </TextField>
              </Grid>
              {formularioState.is_victim === true && (
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-numero"
                    label="TIPO DE VÍCTIMA"
                    variant="outlined"
                    select
                    error={!!errors.victim_type} 
                    helperText={errors.victim_type || ""}
                    value={formularioState.victim_type}
                    onChange={handleVictim_type}
                  >
                    <MenuItem value={"DIRECTA"}>DIRECTA</MenuItem>
                    <MenuItem value={"INDIRECTA"}>INDIRECTA</MenuItem>
                    <MenuItem value={"POTENCIAL"}>POTENCIAL</MenuItem>
                  </TextField>
                </Grid>
              )}
              <Grid item xs={12}>
                  <TextField
                    required
                    select
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-calle"
                    label="EN CASO DE SER USUARIO ANTERIOR ¿CUENTA CON FOLIO OPC?"
                    variant="outlined"
                    error={!!errors.folio_opc}
                    helperText={errors.folio_opc || ""}
                    value={
                      formularioState.folio_opc === true
                        ? "SI"
                        : formularioState.folio_opc === false
                        ? "NO"
                        : ""
                    }
                    onChange={handleFolio_opc}
                  >
                    <MenuItem value="">Seleccione</MenuItem>
                    <MenuItem value="SI">SI</MenuItem>
                    <MenuItem value="NO">NO</MenuItem>
                  </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="SOPC CASO DE SEGUIMIENTO "
                  variant="outlined"
                  error={!!errors.folio_sopc}
                  helperText={errors.folio_sopc || ""}
                  value={formularioState.folio_sopc}
                  onChange={handleFolio_sopc}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="SOPC CASO DE PRIMERA VEZ"
                  variant="outlined"
                  value={formularioState.sopc_first_time}
                  onChange={handleSopc_first_time}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="NOMBRE DE LA PERSONA A QUIEN SE TURNA PARA SEGUIMIENTO"
                  variant="outlined"
                  error={!!errors.assigned_staff}
                  helperText={errors.assigned_staff || ""}
                  value={formularioState.assigned_staff}
                  onChange={handleAssigned_staff}
                />
              </Grid>
              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    crearOrientacion();
                  }}
                >
                  Guardar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openModalEditar}
          onClose={handleCloseEditar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style}>
            <h3 className="TitulosProgramas">EDITAR ORIENTACIÓN</h3>
            <hr />
            <h5>DATOS GENERALES</h5>
            <hr />
            <Grid container columns={12} spacing={3}>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-nombre"
                  label="NOMBRE DEL SOLICITANTE"
                  variant="outlined"
                  error={!!errors.applicant_name}
                  helperText={errors.applicant_name || ""}
                  value={state.orientacionSeleccionado.applicant_name}
                  onChange={handleSeleccionadoApplicant_name}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-telefono"
                  label="TELEFONO"
                  variant="outlined"
                  error={!!errors.aplicant_phone}
                  helperText={errors.aplicant_phone || ""}
                  onChange={handleSeleccionadoAplicant_phone}
                  value={
                    state.orientacionSeleccionado.aplicant_phone !== null
                      ? state.orientacionSeleccionado.aplicant_phone
                      : ""
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-correo"
                  label="CORREO ELECTRÓNICO"
                  variant="outlined"
                  value={
                    state.orientacionSeleccionado.aplicant_email !== null
                      ? state.orientacionSeleccionado.aplicant_email
                      : ""
                  }
                  error={errors.aplicant_email ? true : false}
                  helperText={errors.email || ""}
                  onChange={handleSeleccionadoAplicant_email}
                  onKeyPress={(event) => {
                    maxLengthLimitInput(event, 55, "email");
                  }}
                />
              </Grid>
               <Grid item xs={12}>
                <Autocomplete
                  options={state.municipios || []}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  id="municipality"
                  sx={{
                    borderRadius: "30px",
                  }}
                  value={
                    state.municipios.find(
                      (option) =>
                        option.id === state.orientacionSeleccionado.municipality_id,
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    handleSeleccionadoMunicipality_id(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="MUNICIPIO"
                      error={!!errors.municipality_id}
                      helperText={errors.municipality_id || ""}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-Titulo"
                  label="LOCALIDAD"
                  variant="outlined"
                  select
                  error={!!errors.locality_id}
                  helperText={errors.locality_id || ""}
                  onChange={handleSeleccionadoLocality_id}
                  value={state.orientacionSeleccionado.locality_id || ""}
                >
                  {state.localidades?.length > 0 ? (
                    state.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value={null}>
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="MOTIVO DE ORIENTACIÓN"
                  error={!!errors.reasons_ceeav}
                  helperText={errors.reasons_ceeav || ""}
                  variant="outlined"
                  select
                  onChange={handleSeleccionadoReasons_ceeav}
                  value={state.orientacionSeleccionado.reasons_ceeav}
                >
                  <MenuItem value={"A"}>INFORMACIÓN DE LOS SERVICIOS DE LA CEEAV</MenuItem>
                  <MenuItem value={"B"}>INFORMACIÓN RELATIVA A OTRAS INSTITUCIONES</MenuItem>
                  <MenuItem value={"C"}>USUARIO NUEVO QUE SOLICITA ATENCIÓN DE LA CEEAV</MenuItem>
                  <MenuItem value={"D"}>USUARIO QUE SOLICITA INFORMACIÓN DE CASO</MenuItem>
                  <MenuItem value={"E"}>CONTENCIÓN</MenuItem>
                  <MenuItem value={"F"}>ACOMPAÑAMIENTO</MenuItem>
                  <MenuItem value={"G"}>ASESORÍA PSICOLOGICA</MenuItem>
                  <MenuItem value={"H"}>PSICOTERAPIA</MenuItem>
                  <MenuItem value={"OTRO"}>OTRO</MenuItem>
                </TextField>
              </Grid>
              {state.orientacionSeleccionado.reasons_ceeav === "OTRO" && (
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-other-reason-editar"
                    label="ESPECIFIQUE OTRO MOTIVO"
                    variant="outlined"
                    error={!!errors.other_reason}
                    helperText={errors.other_reason || ""}
                    value={state.orientacionSeleccionado.other_reason || ""}
                    onChange={handleSeleccionadoOther_reason}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoM"
                  label="NARRACIÓN DE LA SOLICITUD"
                  variant="outlined"
                  error={!!errors.reason_description}
                  helperText={errors.reason_description || ""}
                  value={state.orientacionSeleccionado.reason_description}
                  onChange={handleSeleccionadoReason_description}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-TipoUsuario"
                  label="ACCIONES"
                  error={!!errors.actions_ceeav}
                  helperText={errors.actions_ceeav || ""}
                  variant="outlined"
                  select
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) =>
                      selected
                        .map((action) => actionLabels[action] || action)
                        .join(", "),
                  }}
                  onChange={handleSeleccionadoActions_ceeav}
                  value={normalizeActions(
                    state.orientacionSeleccionado.actions_ceeav,
                  )}
                >
                  <MenuItem value={"A"}>SE BRINDÓ INFORMACIÓN</MenuItem>
                  <MenuItem value={"B"}>DERIVACIÓN AL DEPARTAMENTO DE VINCULACIÓN CON INSTITUCIÓN PARA CANALIZACIÓN</MenuItem>
                  <MenuItem value={"C"}>ATENCIÓN DE PRIMER CONTACTO DE LA CEEAV</MenuItem>
                  <MenuItem value={"D"}>DERIVACIÓN A OTRA ÁREA DE LA CEEAV PARA ATENCIÓN</MenuItem>
                  <MenuItem value={"OTRO"}>OTRO</MenuItem>
                </TextField>
              </Grid>
              {normalizeActions(
                state.orientacionSeleccionado.actions_ceeav,
              ).includes("OTRO") && (
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-other-action-editar"
                    label="ESPECIFIQUE OTRA ACCIÓN"
                    variant="outlined"
                    error={!!errors.other_action}
                    helperText={errors.other_action || ""}
                    value={state.orientacionSeleccionado.other_action || ""}
                    onChange={handleSeleccionadoOther_action}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-apellidoM"
                  label="DESCRIPCIÓN DE LA ACCIÓN"
                  variant="outlined"
                  error={!!errors.action_description}
                  helperText={errors.action_description || ""}
                  value={state.orientacionSeleccionado.action_description}
                  onChange={handleSeleccionadoAction_description}
                />
              </Grid>
              <Grid item xs={12}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-calle"
                    label="ES VÍCTIMA"
                    variant="outlined"
                    error={!!errors.is_victim}
                    helperText={errors.is_victim || ""}
                    select
                    value={
                      state.orientacionSeleccionado.is_victim === true
                        ? "SI"
                        : state.orientacionSeleccionado.is_victim === false
                        ? "NO"
                        : ""
                    }
                    onChange={handleSeleccionadoIs_victim}
                  >
                    <MenuItem value="SI">SI</MenuItem>
                    <MenuItem value="NO">NO</MenuItem>
                  </TextField>
              </Grid>
              {state.orientacionSeleccionado.is_victim === true && (
                <Grid item xs={12}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-numero"
                    label="TIPO DE VÍCTIMA"
                    variant="outlined"
                    select
                    error={!!errors.victim_type} 
                    helperText={errors.victim_type || ""}
                    value={state.orientacionSeleccionado.victim_type}
                    onChange={handleSeleccionadoVictim_type}
                  >
                    <MenuItem value={"DIRECTA"}>DIRECTA</MenuItem>
                    <MenuItem value={"INDIRECTA"}>INDIRECTA</MenuItem>
                    <MenuItem value={"POTENCIAL"}>POTENCIAL</MenuItem>
                  </TextField>
                </Grid>
              )}
              <Grid item xs={12}>
                  <TextField
                    required
                    select
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="textFile-calle"
                    label="EN CASO DE SER USUARIO ANTERIOR ¿CUENTA CON FOLIO OPC?"
                    variant="outlined"
                    error={!!errors.folio_opc}
                    helperText={errors.folio_opc || ""}
                    value={
                      state.orientacionSeleccionado.folio_opc === true
                        ? "SI"
                        : state.orientacionSeleccionado.folio_opc === false
                        ? "NO"
                        : ""
                    }
                    onChange={handleSeleccionadoFolio_opc}
                  >
                    <MenuItem value="">Seleccione</MenuItem>
                    <MenuItem value="SI">SI</MenuItem>
                    <MenuItem value="NO">NO</MenuItem>
                  </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="SOPC CASO DE SEGUIMIENTO "
                  variant="outlined"
                  error={!!errors.folio_sopc}
                  helperText={errors.folio_sopc || ""}
                  value={state.orientacionSeleccionado.folio_sopc}
                  onChange={handleSeleccionadoFolio_sopc}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="SOPC CASO DE PRIMERA VEZ"
                  variant="outlined"
                  value={state.orientacionSeleccionado.sopc_first_time}
                  onChange={handleSeleccionadoSopc_first_time}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="textFile-colonia"
                  label="NOMBRE DE LA PERSONA A QUIEN SE TURNA PARA SEGUIMIENTO"
                  variant="outlined"
                  error={!!errors.assigned_staff}
                  helperText={errors.assigned_staff || ""}
                  value={state.orientacionSeleccionado.assigned_staff}
                  onChange={handleSeleccionadoAssigned_staff}
                />
              </Grid>

              <Grid marginLeft="auto" item>
                <ColorButton
                  onClick={() => {
                    editarOrientacion();
                  }}
                >
                  Guardar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={state.openDocumento}
          onClose={() => handleCloseDocumento()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs" sx={style3}>
            <p className="text-center">Documento</p>
            <iframe
              style={{ width: "100%", height: "100%" }}
              id="frameAceptacion"
              title="DOCUMENTO"
              src={`data:application/pdf;base64,${state.urlFrame}`}
              className="preview-iframe"
            ></iframe>
            <Button sx={{ mt: 2 }} onClick={() => handleCloseDocumento()}>
              Cerrar
            </Button>
          </Box>
        </Modal>

        <Modal
          open={state.openModalEliminar}
          onClose={handleCloseEliminar}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="contenedorModalUrs text-center" sx={style2}>
            <h3 className="TitulosProgramas  mb-5">
              ¿ESTÁ SEGURO DE ELIMINAR LA ORIENTACIÓN?
            </h3>
            <Grid container columns={12} spacing={4}>
              <Grid item xs={12}>
                <h4>{state.orientacionSeleccionado.applicant_name}</h4>
              </Grid>

              <Grid margin="auto" item>
                <ColorButton
                  onClick={() => {
                    eliminarOrientacion();
                  }}
                >
                  Si, Eliminar
                </ColorButton>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <ModalText
          open={state.openObservaciones}
          onClose={() => handleCloseObservaciones()}
          descripcion={state.observaciones}
        />
      </div>
    </>
  );
};

export default Orientacion;
